import { render, staticRenderFns } from "./MoneyPaymentRejected.vue?vue&type=template&id=df06c1b0&scoped=true"
var script = {}
import style0 from "./MoneyPaymentRejected.vue?vue&type=style&index=0&id=df06c1b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df06c1b0",
  null
  
)

export default component.exports